import { Link } from "react-router-dom";
import { MapPin, MessageCircle } from "lucide-react";
import { site, categories, waLink, waGeneralMessage } from "../data/store";

export function Footer() {
  return (
    <footer className="bg-navy text-white">
      <div className="mx-auto grid max-w-[1200px] gap-10 px-4 py-12 sm:px-6 md:grid-cols-3">
        <div>
          {(site.logoMarkUrl || site.logoUrl) && (
            <img
              src={site.logoMarkUrl || site.logoUrl}
              alt="Logo Nuansa Jaya Abadi"
              width="96"
              height="48"
              className="h-12 w-auto object-contain"
            />
          )}
          <p className="mt-3 text-lg font-bold">{site.name}</p>
          <p className="mt-1 text-sm text-white/70">
            Toko bangunan yang melayani kebutuhan bahan bangunan dan renovasi di {site.city} dan sekitarnya.
          </p>
          <p className="mt-4 flex items-start gap-2 text-sm text-white/80">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-white/60" aria-hidden="true" />
            <span>
              {site.address}, {site.region}
            </span>
          </p>
          <a
            href={waLink(waGeneralMessage)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="mt-3 flex items-center gap-2 text-sm text-white/80 transition-colors hover:text-white"
          >
            <MessageCircle className="h-4 w-4 shrink-0 text-wa" aria-hidden="true" />
            WhatsApp: {site.whatsappDisplay}
          </a>
          {site.socials.length > 0 && (
            <div className="mt-4 flex gap-3">
              {site.socials.map((s) => (
                <a
                  key={s.label}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${s.label} NJA`}
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-brand"
                >
                  <s.icon className="h-4 w-4" aria-hidden="true" />
                </a>
              ))}
            </div>
          )}
        </div>

        <nav aria-label="Tautan halaman">
          <p className="font-semibold text-white">Halaman</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link className="text-white/70 transition-colors hover:text-white" to="/">Beranda</Link></li>
            <li><Link className="text-white/70 transition-colors hover:text-white" to="/produk">Kategori Barang</Link></li>
            <li><Link className="text-white/70 transition-colors hover:text-white" to="/tentang">Tentang Kami</Link></li>
            <li><Link className="text-white/70 transition-colors hover:text-white" to="/kontak">Kontak & Lokasi</Link></li>
          </ul>
        </nav>

        <nav aria-label="Tautan kategori barang">
          <p className="font-semibold text-white">Kategori Barang</p>
          <ul className="mt-3 grid grid-cols-1 gap-2 text-sm">
            {categories.map((c) => (
              <li key={c.slug}>
                <Link
                  className="text-white/70 transition-colors hover:text-white"
                  to={`/produk/${c.slug}`}
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-white/60">
        © {new Date().getFullYear()} {site.name} — Toko bangunan di {site.city}, Kabupaten Ngada, NTT
      </div>
    </footer>
  );
}
